'use client';
import { cn } from '@pulsex/utils';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';
import { siteHref } from '@/utils/links';

type CategoryProps = {
    item?: any;
    className?: string;
    color?: string;
    paintBg?: boolean;
    isDetails?: boolean;
    isWebsiteOnly?: boolean;
};

export const Category = ({ item, className, color, paintBg, isDetails = false, isWebsiteOnly = false }: CategoryProps) => {
    if (!item?.title) return;

    const isOpinionReverse = item?.title === 'رأي';
    const isPalestine = item?.title === 'فلسطين';
    const isSyria = item?.title === 'سوريا';
    const isPeople = item?.title === 'عالم';

    return (
        <Link
            href={
                isOpinionReverse
                    ? '/category/topics-opinions'
                    : isPeople
                    ? '/category/arab-world'
                    : siteHref(item?.url)
            }
            className={cn(
                'h-fit w-fit cursor-pointer text-xl font-amine-light leading-[1] block mb-2 relative',
                paintBg && 'text-white rounded-full py-[2px] px-4',
                className
            )}
            style={
                paintBg
                    ? {
                          backgroundColor: isPalestine
                              ? 'var(--theme-palestine)'
                              : isSyria
                              ? 'var(--theme-syria)'
                              : color || item?.color || '#a5a5a5',
                      }
                    : { color: color || item?.color }
            }
        >
            {isOpinionReverse && !isDetails ? 'قضاياوآراء' : isPeople ? 'عرب وعالم' : item?.title}
           {isWebsiteOnly &&  <><span className='hidden max-md:inline-block'>|</span><span className='hidden max-md:inline-block'>خاص بالموقع</span></>}
           {isWebsiteOnly &&  <div className='max-md:hidden absolute top-0 h-full flex items-center justify-center right-full -translate-x-2 rounded-b-2xl bg-masterRed text-white px-4 w-max'>خاص بالموقع</div>}
        </Link>
    );
};
